<template>
  <section class="mi-ju-shi-chan">
    <PageBlock title="蜜桔市场行情">
      <div class="content">
        <div ref="chart" style="width: 100%;height: 360px;"></div>
      </div>
    </PageBlock>
  </section>
</template>

<script>
import PageBlock from "@/components/page-block.vue";
import * as echarts from "echarts";
import dayjs from "dayjs";
export default {
  name: 'mi-ju-shi-chan',
  components: {PageBlock},
  props: {
    marketPriceVoList: Array
  },
  watch: {
    marketPriceVoList: {
      handler: (val) => {
        this.chart.dispose()
        this.initChart()
      },
      immediate: true,
      deep: true,
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chart);
      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            let topDiv = '<div>'
            params.forEach((item, index) => {
              if (index === 0) {
                let data = this.marketPriceVoList[item.dataIndex]
                topDiv += `<div>${dayjs(data.date).format('YYYY年MM月')}</div>`
              }
              topDiv += `<div>${item.marker}<span>${item.seriesName}: ${item.value}</span></div>`
            })
            topDiv += '<div>'
            return topDiv
          }
          // axisPointer: {
          //   type: 'cross',
          //   label: {
          //     backgroundColor: '#6a7985'
          //   }
          // }
        },
        legend: {
          data: [
            {
              name: '最高价',
              lineStyle: {
                color: '#5530C6'
              },
              itemStyle: {
                color: '#5530C6'
              }
            },
            {
              name: '平均价',
              lineStyle: {
                color: '#086C7E'
              },
              itemStyle: {
                color: '#086C7E'
              }
            },
            {
              name: '最低价',
              lineStyle: {
                color: '#00FFFF'
              },
              itemStyle: {
                color: '#00FFFF'
              }
            }
          ],
          textStyle: {
            color: '#fff'
          }
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        grid: {
          left: '40',
          bottom: 20
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: this.marketPriceVoList.map(item => dayjs(item.date).format('MM'))
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '元/kg',
            axisLabel: {
              formatter: '{value}',
              color: '#fff'
            },
            splitLine: {
              show: false
            },
          }
        ],
        series: [
          {
            name: '最高价',
            type: 'line',
            // stack: 'Total',
            smooth: true,
            lineStyle: {
              width: 2
            },
            showSymbol: false,
            itemStyle: {
              color: '#5530C6'
            },
            areaStyle: {
              opacity: 0.3,
              shadowOffsetY: 2,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#5530C6'
                },
                {
                  offset: 1,
                  color: '#5530C6'
                }
              ])
            },
            emphasis: {
              focus: 'series'
            },
            data: this.marketPriceVoList.map(item => item.maxPrice)
          },
          {
            name: '平均价',
            type: 'line',
            // stack: 'Total',
            smooth: true,
            lineStyle: {
              width: 2
            },
            showSymbol: false,
            itemStyle: {
              color: '#086C7E'
            },
            areaStyle: {
              opacity: 0.3,
              shadowOffsetY: 2,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#086C7E'
                },
                {
                  offset: 1,
                  color: '#086C7E'
                }
              ])
            },
            emphasis: {
              focus: 'series'
            },
            data: this.marketPriceVoList.map(item => item.avgPrice)
          },
          {
            name: '最低价',
            type: 'line',
            // stack: 'Total',
            smooth: true,
            lineStyle: {
              width: 2
            },
            showSymbol: false,
            itemStyle: {
              color: '#00FFFF'
            },
            areaStyle: {
              opacity: 0.21,
              shadowOffsetY: 2,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#00FFFF'
                },
                {
                  offset: 1,
                  color: '#00FFFF'
                }
              ])
            },
            emphasis: {
              focus: 'series'
            },
            data: this.marketPriceVoList.map(item => item.minPrice)
          }
        ]
      };
      // 设置配置项
      this.chart.setOption(option)
    },
  },
};
</script>

<style scoped>
.chan-pin-man-yi-du {
}
</style>
